<template>
  <a class="personal-area" :href="classeUrl + 'teacher/#!/'+ langLetters +'/session/selectClass/?hideLogout=true'" target="_blank">
    <p class="text">
      {{$t('PERSONAL_AREA')}}
    </p>
  </a>
</template>

<script>
import config from '@/config.js'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      lang: state => state.base.lang
    }),
    classeUrl () {
      return config.classeUrl
    },
    langLetters () {
      if (!this.lang) {
        return 'en'
      } else {
        switch (this.lang.localName) {
          case 'en':
            return 'en'
          case 'he':
            return 'he'
          case 'es':
            return 'esp'
          default:
            return 'en'
        }
      }
    }
  }
}
</script>
